import {
  //Button,
  Card,
  CardContent,
  InputAdornment,
  Paper,
  Table,
  TableBody,
  TextField,
  Typography,
  AppBar,
  Tabs,
  Tab
} from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import { Search } from "@material-ui/icons";
import GridItem from "components/Grid/GridItem.jsx";
import EnhancedTableHead from "components/EnhancedTableHead/EnhancedTableHead.jsx";
import React from "react";
import CustomChip from "components/CustomChip/CustomChip.jsx";

const tabStyle = {
  color: "#6c5cab",
  borderBottom: "2px solid"
};

var tabs = ["Risk", "Medical"];

const QuoteHistoryContainer = props => {
  const  tab  = props.tab;
  return (
    <Grid container>
      <GridItem xs={12} sm={12} md={10} style={{flexBasis: "100%", maxWidth: "100%", margin: 'auto' }}>
        <Card>
          <CardContent>
          
            <div>
              <Grid item xs={12} sm={12} md={12}>
                <Typography variant="headline" className="centerCell">
                  {props.clientName
                    ? `${props.clientName}'s Quotes`
                    : "Manage Quotes"}
                </Typography>
                {props.assistantActive ? (
                  <Typography
                    variant="caption"
                    className="centerCell"
                    gutterBottom
                  >
                    {props.brokerName}
                  </Typography>
                ) : null}
              </Grid>
              <div
                style={{
                  borderBottom: "1px solid #cccccc69",
                  margin: "5px auto",
                  width: "25%",
                  marginBottom: "20px"
                }}
              />
            </div>

            <Paper style={{ overflowX: "auto" }}>
            <AppBar
                        position="static"
                        color="default"
                        style={{ marginBottom: "20px" }}
                      >
                        <Tabs
                          tab={tab}
                          onChange= {e => props.handleChangeTab(e)}
                          indicatorColor="primary"
                          textColor="secondary"
                          scrollable
                          scrollButtons="auto"
                        >
                          {tabs.map((t, i) => {
                            return (
                              <Tab
                                label={t}
                                style={i === tab ? tabStyle : {}}
                                key={t}
                              />
                            );
                          })}
                        </Tabs>
                      </AppBar>
              <Grid container>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  style={{ textAlign: "center" }}
                >
                  <CustomChip
                    text="Create Quote"
                    icon="add"
                    clicked={props.chipClicked}
                    style={{ margin: "25px auto 15px auto" }}
                  />
                </Grid>
                
                <Grid
                  item
                  xs={10}
                  sm={10}
                  md={10}
                  style={{
                    margin: "0 auto",
                    display: "flex"
                  }}
                >
                  <TextField
                    id="input-with-icon-textfield"
                    fullWidth
                    style={{ marginBottom: "30px" }}
                    placeholder={`Search Quote by ${
                      props.clientName ? "" : "Client"
                    } or Date Created(DD/MM/YYYY)`}
                    value={props.searchTerm}
                    onChange={props.handleSearch}
                    label="Search"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <Search />
                        </InputAdornment>
                      )
                    }}
                  />
                  {/* <Button>Search</Button> */}
                </Grid>
              </Grid>
              <Table>
                <EnhancedTableHead
                  order={props.order}
                  orderBy={props.orderBy}
                  onRequestSort={(event, property) =>
                    props.handleRequestSort(event, property)
                  }
                  rowCount={props.items ? props.items.length : 0}
                  columnData={props.columnData}
                />
                <TableBody>{props.tableBody}</TableBody>
              </Table>
            </Paper>
          </CardContent>
        </Card>
      </GridItem>
    </Grid>
  );
};

export default QuoteHistoryContainer;



// WEBPACK FOOTER //
// ./src/views/Quote/containers/QuoteHistoryContainer.jsx